import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import { AuthProvider } from "./auth/AuthContext";
import ProtectedRoute from "./auth/ProtectedRoute";
import LoginPage from "./pages/LoginPage";
import { ProjectProvider } from "./state/projectStore";
import Toolbar from "./components/Toolbar";
import LeftSidebar from "./components/LeftSidebar";
import RightSidebar from "./components/RightSidebar";
import Canvas from "./components/Canvas";
import { Toaster } from "sonner";

function AppShell() {
  return (
    <ProjectProvider>
      <div className="h-screen w-screen flex flex-col bg-[#121417] text-[#F3F4F6] overflow-hidden" data-testid="app-root">
        <Toolbar />
        <div className="flex flex-1 overflow-hidden">
          <LeftSidebar />
          <Canvas />
          <RightSidebar />
        </div>
        <Toaster theme="dark" position="bottom-right" />
      </div>
    </ProjectProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <AppShell />
              </ProtectedRoute>
            }
          />
          {/* Any unknown route → redirect to root (which itself enforces auth) */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
